/**
 * Returns the appropriate field based on the current environment
 */

const getEnvironmentField = <T,>(productionField: T, stagingField: T, fallback?: T) => {
    let field = process.env.GATSBY_ACTIVE_ENV === 'production' ? productionField : stagingField

    if (!field && fallback) {
        field = fallback
    }

    if (!field) {
        throw new Error('No field or fallback option provided')
    }

    return field
}

export default getEnvironmentField
